import React, { useContext, useReducer, useEffect, useState } from "react";
import ReactDOM from "react-dom";
import MaterialTable from "material-table";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/AddBox";
import DataService from "../../../../../Service";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core";
import CoachingRequestFormDetail from "./CoachingassignementFormDetail";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
const useStyles = makeStyles((theme) => ({
  wrapper: {
    padding: "5%",
    paddingTop: "0px",
  },
  tableWrapper: {
    padding: "5%",
  },
  title: {
    fontSize: theme.spacing(3),
    fontWeight: 700,
    padding: theme.spacing(2),
  },
  subTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 500,
  },
  paper: {
    boxShadow:
      "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
    minHeight: "200px",
  },
  detailWrap: {
    padding: "20px",
  },
  root: {
    // borderBottom: 'none !important'
  },
  actions: {
    // borderBottom: 'none !important',
    color: "green",
  },
  hideTable: {
    display: "none",
  },
  showTable: {
    display: "block",
  },
}));

export default function CoachRateCard(props) {
  const classes = useStyles();
  const [currentSelection, setCurrentSelection] = useState({});
  const [CoachinRates, setModuleSetups] = useState([]);
  const [action, setAction] = useState(null);
  const [modules, setModules] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [showTable, setShowTable] = useState(true);
  const [anchorEl, setAnchorEl] = useState(null);
  const [refresh, setRefresh] = useState(false);

  const columns = [
    {
      title: "Program name",
      field: "name",
      headerStyle: {
        textAlign: "left",
        // padding:'10px 26px'
      },
      cellStyle: {
        textAlign: "left",
        // padding:'10px 26px',
        // width:'85%'
      },
    },
    // { title: "Default", field: "default" },
  ];

  const CoachinRate = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
    };
    DataService.getDirectData(
      `/programmes?organisation_id=${props.organisationId}`,
      params
    ).then((res) => {
      setTotalCount(res["total_count"]);
      // if(res.success){
      if (res.programmes && res.programmes.length > 0) {
        let CoachinRates = res.programmes;
        setModuleSetups(CoachinRates);
      }
      setLoading(false);
    });
  };

  const handleClose = (data, id) => {
    let moduleList = [];
    if (action === "create" && data && data.id) {
      moduleList = [data].concat(modules);
      setModules(moduleList);
    } else if (data && data.id) {
      moduleList = modules.map((base) => {
        if (base.id === data.id) {
          return data;
        }
        return base;
      });
      setModules(moduleList);
    } else if (!data && id) {
      moduleList = modules.filter((base) => base.id !== id);
      setModules(moduleList);
    }
    setAction(null);
    setCurrentSelection({});
  };
  useEffect(() => {
    setLoading(true);
    CoachinRate();
    // setRefresh(!refresh)
  }, [page, pageSize, props.organisationId, refresh]);

  const movePreviousPage = () => {
    setShowTable(true);
    setAction(null);
    console.log(`setShowTable`, showTable);
  };

  return (
    <div className={classes.wrapper}>
      {action !== "editCrf" ? (
        <Typography
          style={{ padding: "15px", fontWeight: "bold" }}
          variant="h1"
          color="primary"
        >
          Coaching agreement forms
        </Typography>
      ) : (
        ""
      )}
      <div
        style={{ marginTop: "55px" }}
        id="coach-rate-card-border"
        className={action === "editCrf" ? classes.hideTable : classes.showTable}
      >
        {
          <MaterialTable
            title=""
            classes={{
              root: classes.root,
              actions: classes.actions,
            }}
            options={{
              rowStyle: {
                // borderBottom: 'none',
              },
              cellStyle: {
                // borderBottom: 'none',
              },
            
              pageSizeOptions:[20,50,75,100],
            headerStyle: {
              position: "sticky",
              top: "0",
              fontWeight: "bold",
            },
            maxBodyHeight: "600px" ,
              actionsColumnIndex: -1,
              search: false,
              actionsCellStyle: {
                // borderBottom: 'none',
              },
              pageSize: pageSize,
              total: totalCount,
              emptyRowsWhenPaging: false,
            }}
            // options={tableOptions}
            style={{ width: "55%" }}
            columns={columns}
            data={CoachinRates}
            totalCount={totalCount}
            page={page}
            onRowClick={(e, rowData) => {
              setCurrentSelection(rowData);
            }}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              setPageSize(pageSize);
            }}
            onSearchChange={(search) => {
              setSearchText(search);
            }}
            localization={{
              header: {
                actions: "Edit",
              },
            }}
            actions={[
              {
                icon: () => <EditIcon fontSize="small" />,
                iconProps: { style: { fontSize: "14px", color: "green" } },
                tooltip: <TooltipWrapper text="Edit" />,
                onClick: (event, rowData) => {
                  setCurrentSelection(rowData);
                  setAction("editCrf");
                  setShowTable(false);
                },
              },
            ]}
          />
        }
      </div>
      <div className={!showTable ? classes.showTable : classes.hideTable}>
        <IconButton onClick={movePreviousPage} edge="start">
          <ArrowBackIosIcon
            style={{ fontSize: 25, marginTop: "-3px" }}
            color="secondary"
          />
        </IconButton>
        <Typography
          component="span"
          variant="h1"
          color="primary"
          style={{
            padding: "15px",
            fontWeight: "bold",
            // color: "#3B86FF",
          }}
        >
          Coaching agreement form - {currentSelection.name}
        </Typography>
      </div>
      {action && (
        <div>
          <CoachingRequestFormDetail
            actionProgram={action}
            CoachinRate={CoachinRate}
            programme_id={currentSelection.id}
            data={currentSelection}
            handleClose={handleClose}
          />
        </div>
      )}
    </div>
  );
}
